import React from 'react';
import { Box, Stack, Skeleton } from '@mui/joy';

function BillDetailSkeleton() {
  return (
    <Stack spacing={6} padding={4} sx={{ maxWidth: '1280px', width: '100%' }}>
      <Stack spacing={2}>
        <Skeleton variant="text" width="15%" height={24} sx={{ borderRadius: '8px' }} />
        <Skeleton variant="text" width="70%" height={48} sx={{ borderRadius: '8px' }} />
        <Skeleton variant="text" width="90%" height={32} sx={{ borderRadius: '8px' }} />
        <Skeleton variant="text" width="95%" height={24} />
        <Skeleton variant="text" width="88%" height={24} />
        <Skeleton variant="rectangular" width="180px" height={40} sx={{ borderRadius: '8px', mt: 2 }} />
      </Stack>

      <Skeleton
        variant="rectangular"
        height={180}
        sx={{
          borderRadius: '20px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.06)'
        }}
      />

      <Skeleton
        variant="rectangular"
        height={220}
        sx={{
          borderRadius: '24px',
          boxShadow: '0 20px 50px rgba(0,0,0,0.08)'
        }}
      />

      <Stack spacing={3}>
        {[1, 2, 3].map((item) => (
          <Box key={item}>
            <Skeleton variant="text" width="30%" height={32} sx={{ mb: 2 }} />
            <Skeleton variant="text" width="100%" height={20} />
            <Skeleton variant="text" width="95%" height={20} />
            <Skeleton variant="text" width="88%" height={20} />
          </Box>
        ))}
      </Stack>
    </Stack>
  );
}

export default BillDetailSkeleton;
